import { Outlet } from 'react-router-dom';

const GuestStatLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
}   
export default GuestStatLayout;